<template lang="html">
  <div></div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
    var id = this.$route.query.order_no
    sessionStorage.setItem('orderNo', id)
    this.$router.push({ path: '/app/workspace/inbox' })
  }
}
</script>

<style lang="css">
</style>
